import { auth } from "./firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  OAuthProvider,
  signOut,
  sendSignInLinkToEmail,
} from "firebase/auth";

// 🔵 Google
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user;
};

// 🍏 Apple
export const signInWithApple = async () => {
  const provider = new OAuthProvider("apple.com");
  const result = await signInWithPopup(auth, provider);
  return result.user;
};


export const logout = () => {
  return signOut(auth);
};

export const sendEmailLink = async (email: string, id: string, needsHydrating: boolean) => {

  const link = needsHydrating ? `${process.env.REACT_APP_WEB_URL}/routeconfirmation/${id}/rehydrate` : `${process.env.REACT_APP_WEB_URL}`
  const actionCodeSettings = {
    url: link, // your route
    handleCodeInApp: true,
  };

  await sendSignInLinkToEmail(auth, email, actionCodeSettings);

  // 🔑 IMPORTANT (Firebase requirement)
  window.localStorage.setItem("emailForSignIn", email);

}
